<template>
  <div
    class="flex my-8 w-full grid grid-cols-1 gap-4"
    style="min-height: 200px"
  >
    <ResumoChurn class="h-full" />
    <ResumoFreeze class="h-full" />
    <ResumoEmpresas class="h-full"/>
  </div>
</template>

<script>
import ResumoChurn from "@/views/Home/Administrativo/components/ResumoChurn";
import ResumoFreeze from "@/views/Home/Administrativo/components/ResumoFreeze";
import ResumoEmpresas from "@/views/Home/Administrativo/components/ResumoEmpresas";

export default {
  name: "Administrativo",
  components: { ResumoChurn, ResumoFreeze,ResumoEmpresas},
};
</script>

<style scoped>
</style>
